import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.t5h().n51() : headers;
  return DelegatedCall().r5j(_this__u8e3s4.o5h_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static r5j(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.t5h().n51() : responseHeaders;
        var $this = this.s5j(client);
        $this.q5h_1 = new (DelegatedRequest())($this, originCall.t5j());
        $this.r5h_1 = new (DelegatedResponse())($this, originCall.t5h(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.y5j_1 = origin;
        this.z5j_1 = call;
      }
      a5k() {
        return this.z5j_1;
      }
      sv() {
        return this.y5j_1.sv();
      }
      b5k() {
        return this.y5j_1.b5k();
      }
      c5k() {
        return this.y5j_1.c5k();
      }
      u5j() {
        return this.y5j_1.u5j();
      }
      h2o() {
        return this.y5j_1.h2o();
      }
      n51() {
        return this.y5j_1.n51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.n51() : headers;
        super();
        this.d5k_1 = call;
        this.e5k_1 = origin;
        this.f5k_1 = content;
        this.g5k_1 = headers;
        this.h5k_1 = this.e5k_1.sv();
      }
      a5k() {
        return this.d5k_1;
      }
      n51() {
        return this.g5k_1;
      }
      i5k() {
        return this.f5k_1(this.e5k_1);
      }
      sv() {
        return this.h5k_1;
      }
      j5k() {
        return this.e5k_1.j5k();
      }
      k5k() {
        return this.e5k_1.k5k();
      }
      l5k() {
        return this.e5k_1.l5k();
      }
      m5k() {
        return this.e5k_1.m5k();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
